"use strict";
import React from "react";
import PropTypes from "prop-types";

class FormsyFormErrorsProvider extends React.Component {

    unMounting = false;

    constructor(props) {
        super(props);

        this.state = {
            errors: {}
        };
    }

    getChildContext() {
        return {
            formsyFormErrorsProvider: {
                errors: this.state.errors
            }
        };
    }

    componentWillUnmount() {
        this.unMounting = true;
    }

    addFormErrors(errors) {
        if (this.unMounting) {
            return;
        }

        return this.setState({
            errors: { ...this.state.errors, ...errors }
        });
    }

    clearFormErrors(errorNames) {
        if (this.unMounting) {
            return;
        }

        if (!errorNames) {
            return this.setState({ errors: {} });
        } else if (Array.isArray(errorNames)) {
            const nextErrors = {};

            Object.keys(this.state.errors).forEach(errorName => {
                if (!errorNames.includes(errorName)) {
                    nextErrors[errorName] = this.state.errors[errorName];
                }
            });

            return this.setState({ errors: nextErrors });
        }
    }

    _injectCallbacks(callback) {
        if (callback) {
            return (...args) => callback(...args, this.addFormErrors.bind(this), this.clearFormErrors.bind(this));
        }
    }

    render() {
        const { children } = this.props;

        return React.cloneElement(children, {
            onSubmit: this._injectCallbacks(children.props.onSubmit),
            onValidSubmit: this._injectCallbacks(children.props.onValidSubmit),
            onInvalidSubmit: this._injectCallbacks(children.props.onInvalidSubmit)
        });
    }

}

FormsyFormErrorsProvider.propTypes = {
    children: PropTypes.element.isRequired
};

FormsyFormErrorsProvider.childContextTypes = {
    formsyFormErrorsProvider: PropTypes.shape({
        errors: PropTypes.object.isRequired
    }).isRequired
};

module.exports = FormsyFormErrorsProvider;